import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { ExpandLess, ExpandMore, AccountCircle } from '@material-ui/icons';
import { ReactComponent as PremiumBonusIcon } from '../../../../_FSD/shared/assets/icons/books.svg';

import {
  Box,
  Theme,
  IconButton,
  Typography,
} from '@material-ui/core';

import { parsePhoneNumber } from '../../../../helpers/reserveHelpers';
import classNames from "classnames";

const useStyles = makeStyles((theme: Theme) => ({
  fakeAvatar: {
    fontSize: 77,
    color: '#c5c5c5',
    margin: '-3px 12px 0 -6px',
  },
  clickableAvatar: {
    cursor: 'pointer',
  },
  name: {
    fontSize: 24,
    fontWeight: 500,
    color: 'white',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  nameContainer: {
    width: 300,
    [theme.breakpoints.up('lg')]: {
      width: 320,
    },
  },
  clickableName: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  phone: {
    fontSize: 16,
    color: 'white',
    opacity: 0.65,
  },
}));

interface SnackbarHeaderProps {
  id: string;
  name: string;
  phone: string;
  open: boolean;
  clickPerson: (phone: string) => void;
  onToggle: (key: string) => void;
  isGuest: boolean;
  isPremiumBonus: boolean;
}

function Header(props: SnackbarHeaderProps) {
  const {
    id,
    name,
    phone,
    open,
    clickPerson,
    onToggle,
    isGuest,
    isPremiumBonus,
  } = props;

  const classes = useStyles();

  return (
    <Box display="flex" mb={1}>
      <Box clone>
        <AccountCircle
          className={classNames(classes.fakeAvatar, {
            [classes.clickableAvatar]: !isGuest
          })}
          onClick={() => clickPerson(phone)}
        />
      </Box>
      <Box flexGrow={1} alignSelf="center">
        <Box className={classes.nameContainer} display="flex" flexDirection="row" justifyContent="flex-start">
          <Typography
            className={classNames(classes.name, {
              [classes.clickableName]: !isGuest
            })}
            title={name.length > 20 ? name : ''}
            onClick={() => clickPerson(phone)}
          >
            {name}
          </Typography>
          {isPremiumBonus && <Box
            height="30px"
            width="30px"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            borderRadius={8}
            border="1px solid #E4E7EC"
            bgcolor="#FFF"
            marginLeft="12px"
          >
            <PremiumBonusIcon height="24px" width="20px" />
          </Box>}
        </Box>

        <Typography className={classes.phone}>
          {parsePhoneNumber(phone)}
        </Typography>
      </Box>
      <Box clone alignSelf="start">
        <IconButton
          onClick={() => onToggle(id)}
          style={{ color: '#c5c5c5', marginTop: -9 }}
        >
          {open ? <ExpandLess color="inherit" /> : <ExpandMore color="inherit" />}
        </IconButton>
      </Box>
    </Box>
  );
}

export default Header;
